import React from 'react';

const Button = ({ children, className, ...props }) => {
  return (
    <button
      {...props}
      className={`flex items-center gap-2 justify-center py-2.5 px-[12px] rounded text-[14px] leading-[19.6px] font-satoshi-bold bg-[#252526] text-white disabled:bg-[#F6F6F6] disabled:text-[#808285] ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
